import { Zap, Sparkles, Loader2, CheckCircle2 } from "lucide-react";

interface PipelineProgressModalProps {
  pipelineProgress: {
    kind: 'autoIa' | 'analyze';
    step: number;
    labels: string[];
    successMessage?: string;
    fallbackMessage?: string;
  } | null;
  onClose: () => void;
}

export function PipelineProgressModal({ pipelineProgress, onClose }: PipelineProgressModalProps) {
  if (!pipelineProgress) return null;

  return (
    <div className="fixed inset-0 z-[10001] flex items-center justify-center p-4 bg-black/70" onClick={() => pipelineProgress.successMessage && onClose()}>
      <div className="bg-[#0a0a0a] border border-white/20 rounded-2xl shadow-2xl max-w-sm w-full p-6 space-y-4" onClick={e => e.stopPropagation()}>
        <h3 className="text-base font-bold text-white flex items-center gap-2">
          {pipelineProgress.kind === 'autoIa' ? <Zap size={18} className="text-green-500" /> : <Sparkles size={18} className="text-violet-400" />}
          {pipelineProgress.successMessage 
            ? (pipelineProgress.kind === 'autoIa' ? 'Auto IA terminé' : 'Analyse IA terminée') 
            : (pipelineProgress.kind === 'autoIa' ? 'Auto IA en cours…' : 'Analyse IA en cours…')}
        </h3>
        {pipelineProgress.successMessage ? (
          <div className="flex items-center gap-3 p-3 rounded-xl bg-emerald-500/15 border border-emerald-500/30">
            <CheckCircle2 size={24} className="text-green-500 shrink-0" />
            <p className="text-sm font-semibold text-emerald-300">{pipelineProgress.successMessage}</p>
          </div>
        ) : pipelineProgress.fallbackMessage ? (
          <div className="flex items-center gap-3 p-3 rounded-xl bg-amber-500/15 border border-amber-500/30">
            <Loader2 size={20} className="text-amber-400 shrink-0 animate-spin" />
            <p className="text-sm text-amber-300">{pipelineProgress.fallbackMessage}</p>
          </div>
        ) : (
          <ul className="space-y-2">
            {pipelineProgress.labels.map((label, i) => (
              <li key={i} className="flex items-center gap-2 text-sm">
                {i < pipelineProgress.step ? (
                  <CheckCircle2 size={16} className="text-green-500 shrink-0" />
                ) : i === pipelineProgress.step ? (
                  <Loader2 size={16} className="text-blue-400 shrink-0 animate-spin" />
                ) : (
                  <span className="w-4 h-4 rounded-full border border-white/30 shrink-0" />
                )}
                <span className={i <= pipelineProgress.step ? 'text-white/90' : 'text-white/40'}>{label}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
